import { User } from '../user';
import { InvoiceLineItemDiscountType } from './invoice-line-item-discout-type';
import { InvoiceLineItemTax } from './invoice-line-item-tax';

export class InvoiceLineItem {
  id: number;
  invoiceId: number;
  note: string;
  discountPrice?: number;
  discountType?: InvoiceLineItemDiscountType;
  unitPrice: number;
  quantity: number;
  total: number;
  serviceTemplateId: number;
  serviceType: string;
  serviceTypeDescription: string;
  clinicProductId?: number;
  observationListId?: number;
  isManual: boolean;
  isRecommendedProduct: boolean;
  isDeleted: boolean;
  finalTotal: number;
  isCredit: boolean;
  serviceId?: number;
  addBackToInventory: boolean;
  relatedInvoiceLineItemId?: number;
  invoiceLineItemTaxes: InvoiceLineItemTax[];
  attributedToUserId: string;
  attributedToUser: User;
  plannedTreatmentMultipleId: number;
  isPaid?: boolean = false;
  membershipId?: number;
  patientMembershipId?: number;
  isTip?: boolean;

  constructor(init?: Partial<InvoiceLineItem>) {
    Object.assign(this, init);
    // Ensure default still applies if undefined
    if (this.isTip === undefined) {
      this.isTip = false;
    }
  }
}
